import { visit } from 'unist-util-visit'

export const iframe = () => {
  return (tree) => {
    visit(tree, 'element', (node) => {
      const { tagName, type, properties, children, position, wrapped = false } = node
      if (tagName === 'iframe' && !wrapped) {
        node.type = 'element'
        node.tagName = 'div'
        node.properties = { 'data-wrapper': 'iframe' }
        node.children = [
          {
            wrapped: true,
            type,
            tagName,
            properties,
            position,
            children,
          },
        ]
      }
    })
  }
}
